import { render, staticRenderFns } from "./vacancy.vue?vue&type=template&id=5e77bca2&scoped=true&"
import script from "./vacancy.vue?vue&type=script&lang=ts&"
export * from "./vacancy.vue?vue&type=script&lang=ts&"
import style0 from "./vacancy.vue?vue&type=style&index=0&id=5e77bca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e77bca2",
  null
  
)

export default component.exports